import * as React from "react";
import BaseDialog from "../modelDialogs/BaseDialog";

export async function estadaConfirm(title: string, text: string): Promise<boolean> {
  return new Promise<boolean>((resolve) => {
    state.dialogManager.openDialog(
      <ConfirmDialog
        text={text}
        title={title}
        onClose={() => {
          return true;
        }}
        onAbort={() => {
          resolve(false);
          return true;
        }}
        onOk={() => {
          resolve(true);
          return true;
        }}
      />,
    );
  });
}

export default function ConfirmDialog(props: {
  className?: string;
  title: string;
  text: string;
  onOk?: () => boolean;
  onOkAsync?: () => Promise<boolean>;
  onClose?: () => boolean;
  onAbort?: () => boolean;
  okCaption?: string;
  abortCaption?: string;
  hideXButton?: boolean;
  noAbortButton?: boolean;
}): JSX.Element {
  const {
    className,
    title,
    text,
    onOk,
    onOkAsync,
    onClose,
    okCaption,
    abortCaption,
    hideXButton,
    onAbort,
    noAbortButton,
  } = props;

  return (
    <BaseDialog
      className={className}
      title={title}
      onOk={onOk}
      onOkAsync={onOkAsync}
      onClose={onClose}
      onAbort={onAbort}
      okCaption={okCaption || state.translate("confirm", "Bestätigen")}
      abortCaption={abortCaption || state.translate("cancle", "Abbrechen")}
      hideXButton={hideXButton == undefined ? true : hideXButton}
      noAbortButton={noAbortButton}
    >
      <div style={{ padding: "20px", whiteSpace: "pre-line" }}>{text}</div>
    </BaseDialog>
  );
}
